import React from "react"
import PropTypes from "prop-types"
import {Table} from "antd"
import {defaultPagination, makeDefaultFilters, StatusIndication} from "../../util/Util";


const LovTable = ({loading, dataSource, handleEdit, isLocal, onSelectChange}) => {
    const columns = [
        {title: 'Code', dataIndex: 'code'},
        {title: 'Label', dataIndex: 'label'},
    ];

    const rowSelection = !isLocal ? {
        type: 'radio',
        onChange: (selectedRowKeys) => {
            if (selectedRowKeys.length > 0) onSelectChange(selectedRowKeys[0]);

        }
    } : null;
    
    if (isLocal) {
        columns.splice(0, 0, {title: 'Country', render: (text, record) => record.code.substring(0, 2), filters: makeDefaultFilters(dataSource, lov => lov.code.substring(0, 2))},)
    } else {
        // alter columns
        columns.push(
            {title: 'Comment', dataIndex: 'translation'},
            {
                title: 'Active', dataIndex: 'status', render: (status) => <StatusIndication active={status}/>,
                filters: [{text: 'Active', value: true}, {text: 'Inactive', value: false}]
            }
        )
    }
    
    return <Table dataSource={dataSource}  columns={columns} size="small" rowKey={lov => lov.code}
                  loading={loading} pagination={defaultPagination(20)} rowSelection={rowSelection}
    />
};

LovTable.propTypes = {
    loading: PropTypes.bool.isRequired,
    dataSource: PropTypes.array.isRequired,
    handleEdit: PropTypes.func.isRequired,
    onSelectChange: PropTypes.func,
    isLocal: PropTypes.bool.isRequired
};

export default LovTable


// WEBPACK FOOTER //
// ./src/js/lovs/manage/LovTable.js